import { env, type ENV } from "@monta/env";

/**
 * The `fixString` function takes a string and an optional base URL parameter, and returns the string
 * with the base URL prepended if it is not already present.
 * @param {string} s - A string that represents a URL or a path.
 * @param [baseURL] - The `baseURL` parameter in the `fixString` function is an optional parameter that
 * specifies the base URL to be used for fixing the input string `s`. If a `baseURL` is provided, the
 * function will check if the input string already contains a valid URL (starting with `http
 * @returns The `fixString` function returns a modified string based on the input parameters. If a
 * `baseURL` is provided, it checks if the input string `s` already contains a valid URL (starting with
 * `http://` or `https://`). If it does, the original string `s` is returned. If not, it concatenates
 * the `baseURL` value from the `env
 */
export const fixString = (s: string, baseURL?: keyof ENV) => {
  if (!baseURL) return s;
  const hasBaseURL = /^https?:\/\//i.test(s);
  if (hasBaseURL) return s;
  return `${env[baseURL]}${s}`;
};
